export default __webpack_public_path__ + "static/media/step3.cebc8239.svg";